import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { EmployerManagementView } from './views/EmployerManagementView';

export const employerRoutes: RouteObject[] = [
    {
        path: '/admin/employers',
        element: <EmployerManagementView />,
        errorElement: <ErrorBoundary />,
    }
];
